import { BaseService } from "./BaseService";

export class TaskService extends BaseService {

    constructor(url) {
        
        super(url);
    }

    async getTasks() {
        return this.getAll()
    }

    async getTaskById() {
        return this.get()
    }

    async changeStatus(params) {
        return this.create(params)
    }

}